import React, { forwardRef, useState } from "react";
import type { ForwardedRef, InputHTMLAttributes } from "react";

interface IAnimatedLabelInputProps
	extends InputHTMLAttributes<HTMLInputElement> {
	className?: string;
	label: string;
	isPassword?: boolean;
	name?: string;
	isLabelAnimated?: boolean;
}

const InputLabel = ({
	children,
	hasText,
	className,
}: {
	children: React.ReactNode;
	hasText: boolean;
	className?: string;
}) => {
	return (
		// biome-ignore lint/a11y/noLabelWithoutControl: <explanation>
		<label
			className={`
        absolute 
        pointer-events-none 
        origin-top-left 
        transition-transform 
        duration-200 
        ease-in-out 
        text-textColor
        text-xs
        ${
					hasText
						? "translate-y-0 scale-90 text-gray-600"
						: "translate-y-5 scale-100"
				}
        peer-focus:translate-y-0 
        peer-focus:scale-90 
        peer-focus:text-gray-600
        ${className}
      `}
		>
			{children}
		</label>
	);
};

export const AnimatedLabelInput = forwardRef(
	(
		{
			className,
			label,
			isPassword,
			name,
			isLabelAnimated = true,
			...props
		}: IAnimatedLabelInputProps,
		ref: ForwardedRef<HTMLInputElement>,
	) => {
		const [inputValue, _] = useState("");
		const type = isPassword ? "password" : "text";
		// removed controlled input because react-hook-form uses refs to control/grab the value
		return (
			<div className={`flex flex-1 ${className}`}>
				<input className="pt-[20px] px-0 box-border border-0 text-sm leading-6 outline-none flex-1 text-textColor bg-transparent"  {...props} type={type} ref={ref} />
				<InputLabel hasText={isLabelAnimated ? Boolean(inputValue) : true}>
					{label}
				</InputLabel>
			</div>
		);
	},
);
